<template>
  <v-container grid-list-md text-xs-center class="pt-0">
    <v-layout row wrap>
      <v-flex xs3>
        <v-select
          outline
          :items="types"
          item-text='text'
          item-value='value'
          class="input-group--focused"
          label="Exam Type"
          type="text"
        ></v-select>
      </v-flex>
      <v-flex xs3>
        <v-text-field outline label="Number of questions"></v-text-field>
      </v-flex>
      <v-flex xs6>
        <v-text-field outline label="Exam Name"></v-text-field>
      </v-flex>
      <v-flex xs3>
        <v-select
          outline
          :items="workMin"
          class="input-group--focused"
          label="Duration"
          type="number"
        ></v-select>
      </v-flex>
      <v-flex xs3>
        <v-select
          outline
          :items="typs"
          class="input-group--focused"
          label="Exam Type"
          type="number"
        ></v-select>
      </v-flex>
      <v-flex xs12 class="text-xs-right">
        <v-btn color="primary no-shadow right text-white" to="/examstab#tests" dark>Add Exam</v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
  /*eslint-disable */

  export default {
    data: () => ({
       workMin: [30, 45, 90, 135, 180, 225, 270],
      typs: ['Random', 'Mannual'],
      types: [
        {text: 'Teori test', value: 'teori test'},
        {text: 'Kørsel test', value: 'kørsel test'},
        {text: 'Manøvre test', value: 'manøvre test'},
        {text: 'Glatbane test', value: 'glatbane test'},
        {text: 'Other test', value: 'other test'}
      ]
    })
  }
</script>



// WEBPACK FOOTER //
// src/pages/pages/exams/CreateTest.vue